import React from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap';
import { RiToolsFill } from "react-icons/ri";
import { FaShieldVirus } from "react-icons/fa";

const cardShell = {
    background: "var(--vz-secondary-bg, #fff)",
    border: "1px solid var(--vz-border-color)",
    borderRadius: 10,
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    overflow: "hidden",
    height: "100%",
};

const CHIP = {
    width: 32,
    height: 32,
    borderRadius: 8,
    border: "1px solid rgba(255, 91, 0, 0.55)",
    background: "rgba(255, 91, 0, 0.08)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
};


function AntivirusPatchReport() {

    return (

        <div>
            <Row className="gy-4 mt-3">
                <Col md={6}>
                    <Card style={cardShell}>
                        <div style={{ padding: "14px 18px", borderBottom: "1px solid var(--vz-border-color)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <h4 className="fw-bold mb-0" style={{color:"#838181"}}>
                                <span style={{ ...CHIP, marginRight: 8 }}>
                                    <FaShieldVirus size={18} style={{ color:"#FF5B00", lineHeight: 1 }} />
                                </span>
                                Antivirus Report
                            </h4>
                        </div>
                        <CardBody className="d-flex flex-column justify-content-between" style={{ padding: "18px" }}>
                            <p className="card-text text-muted mb-3">
                                Provides antivirus status and protection coverage across agents.
                            </p>
                            <div className="text-center">
                                <button className='rounded btn btn-outline-primary'>
                                    View Details
                                </button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>

                <Col md={6}>
                    <Card style={cardShell}>
                        <div style={{ padding: "14px 18px", borderBottom: "1px solid var(--vz-border-color)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <h4 className="fw-bold mb-0" style={{color:"#838181"}}>
                                <span style={{ ...CHIP, marginRight: 8 }}>
                                    <RiToolsFill size={18} style={{ color:"#FF5B00", lineHeight: 1 }} />
                                </span>
                                Patch Management Report
                            </h4>
                        </div>
                        <CardBody className="d-flex flex-column justify-content-between" style={{ padding: "18px" }}>
                            <p className="card-text text-muted mb-3">
                                Summarizes pending and applied patches for system stability.
                            </p>
                            <div className="text-center">
                                <button className='rounded btn btn-outline-primary'>
                                    View Details
                                </button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default AntivirusPatchReport
